/**
 * Customização do EventDatesInfo do Volto 18.33.1 (o "Quando" da página do
 * evento e do EventDetails). Duas mudanças no When:
 *
 *  - as datas e horas saem no horário de Brasília, o fuso do portal, e não no
 *    de quem lê: quem abre a intranet num DSEI de outro fuso via o evento de
 *    dia inteiro no dia anterior;
 *  - o texto é em português ("a", "das … às …", "a partir das"), no lugar do
 *    "to"/"from" em inglês que o core deixou fixo (TODO I18N no original).
 *
 * datesForDisplay e Recurrence ficam como no core.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'semantic-ui-react';
import cx from 'classnames';

import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import {
  dataEmBrasilia,
  formatar,
} from '../../../../components/DataDoEvento/brasilia';

export const datesForDisplay = (start, end, moment) => {
  const mStart = moment(start);
  const mEnd = moment(end);
  if (!mStart.isValid() || !mEnd.isValid()) {
    return null;
  }
  const sameDay = mStart.isSame(mEnd, 'day');
  const sameTime = mStart.isSame(mEnd, 'minute');
  return {
    sameDay,
    sameTime,
    startDate: mStart.format('ll'),
    startTime: mStart.format('LT'),
    endDate: mEnd.format('ll'),
    endTime: mEnd.format('LT'),
  };
};

const DATA = { day: 'numeric', month: 'long', year: 'numeric' };
const HORA = { hour: '2-digit', minute: '2-digit' };

/** Datas e horas do evento no horário de Brasília (ou null, se inválidas). */
export const quandoEmBrasilia = (start, end) => {
  const inicio = dataEmBrasilia(start);
  const fim = dataEmBrasilia(end || start);
  if (!inicio || !fim) return null;
  return {
    mesmoDia: inicio === fim,
    mesmaHora: new Date(start).getTime() === new Date(end || start).getTime(),
    dataInicio: formatar(start, DATA),
    horaInicio: formatar(start, HORA),
    dataFim: formatar(end || start, DATA),
    horaFim: formatar(end || start, HORA),
  };
};

export const When = ({ start, end, whole_day, open_end }) => {
  const q = quandoEmBrasilia(start, end);
  if (!q) return null;
  return (
    <p
      className={cx('event-when', {
        'same-day': q.mesmoDia,
        'same-time': q.mesmaHora,
        'whole-day': whole_day,
        'open-end': open_end,
      })}
    >
      {!q.mesmoDia ? (
        <>
          <span className="start">
            <span className="start-date">{q.dataInicio}</span>
            {!whole_day && (
              <>
                , <span className="start-time">{q.horaInicio}</span>
              </>
            )}
          </span>
          {!open_end && (
            <>
              {' a '}
              <span className="end">
                <span className="end-date">{q.dataFim}</span>
                {!whole_day && (
                  <>
                    , <span className="end-time">{q.horaFim}</span>
                  </>
                )}
              </span>
            </>
          )}
        </>
      ) : (
        <>
          <span className="start-date">{q.dataInicio}</span>
          {open_end && !whole_day && (
            <>
              , a partir das <span className="start-time">{q.horaInicio}</span>
            </>
          )}
          {!(whole_day || open_end) && (
            <>
              , das <span className="start-time">{q.horaInicio}</span> às{' '}
              <span className="end-time">{q.horaFim}</span>
            </>
          )}
        </>
      )}
    </p>
  );
};

When.propTypes = {
  start: PropTypes.string.isRequired,
  end: PropTypes.string,
  whole_day: PropTypes.bool,
  open_end: PropTypes.bool,
};

export const Recurrence_ = ({
  recurrence,
  start,
  moment: momentlib,
  rrule,
}) => {
  const moment = momentlib.default;
  const { RRule, rrulestr } = rrule;
  if (recurrence.indexOf('DTSTART') < 0) {
    var dtstart = RRule.optionsToString({
      dtstart: new Date(start),
    });
    recurrence = dtstart + '\n' + recurrence;
  }
  const rule = rrulestr(recurrence, { unfold: true, forceset: true });

  return (
    <List
      items={rule
        .all()
        .map((date) => datesForDisplay(date, undefined, moment))
        .map((date) => date.startDate)}
    />
  );
};
export const Recurrence = injectLazyLibs(['moment', 'rrule'])(Recurrence_);

Recurrence.propTypes = {
  recurrence: PropTypes.string.isRequired,
  start: PropTypes.string.isRequired,
};
